<p-progressBar [value]="interval()"></p-progressBar>
